//  @Date: 2021-04-13 fsnt
//  * @methods 埋点
//  * @params accId 所属微信平台
//     actionCode 行为标识
//     extraData其他额外数据(必须为json字符串数据)
//     openId用户微信授权标识
//     referer 来源地址
//     tel 手机号
//     unionId 用户微信统一授权标识
//     userId 用户id
//     wxUserAccId 所属微信平台

import request from "@/utils/request";
import formalParams from "@/utils/formalParams";

// 埋点
let report = params =>
	request("", "application/json").post(
		"/qianke/action/recorder/api/front/action/report",
		params
	);

export default (actionCode, extraData) => {
	try {
		let buriedPoint = localStorage.getItem("buriedPoint")
			? JSON.parse(localStorage.getItem("buriedPoint"))
			: {};
		let tel = localStorage.getItem("userInfo")
			? JSON.parse(localStorage.getItem("userInfo") || {}).tel
			: "";
		let params = {
			actionCode,
			extraData: JSON.stringify({
				origin: formalParams().origin,
				...extraData
			}),
			...buriedPoint,
			referer: window.location.href,
			tel
		};
		report(params);
	} catch (e) {
		console.log(e, "<=埋点");
	}
};



// WEBPACK FOOTER //
// ./src/utils/buriedPoint.js